/** Ficha do atleta criado pelo jogador (GDD, seção 4; item 2.7). */
import { BUILDS, HEIGHTS, SEXES, type Build, type Height, type Sex } from "./athlete.js";
import { isValidAppearance, type Appearance } from "./appearance.js";
import { POSITIONS, type Position } from "./rules.js";

export const PROFILE_LIMITS = {
  nameMin: 2,
  nameMax: 20,
  numberMin: 1,
  numberMax: 99,
} as const;

export interface AthleteProfile extends Appearance {
  name: string;
  number: number;
  position: Position;
  sex: Sex;
  height: Height;
  build: Build;
}

export type ProfileProblem =
  | "nome-curto"
  | "nome-longo"
  | "nome-caracteres"
  | "numero"
  | "posicao"
  | "corpo"
  | "aparencia";

/** Letras (com acento), espaço, apóstrofo, hífen e ponto; começa com letra. */
const NAME_PATTERN = /^\p{L}[\p{L}' .-]*$/u;

/** Tira espaços das pontas e junta espaços repetidos. */
export function normalizeName(name: string): string {
  return name.trim().replace(/\s+/g, " ");
}

/** Lista o que impede a ficha de ser salva; vazia quando está tudo certo. */
export function profileProblems(p: AthleteProfile): ProfileProblem[] {
  const problems: ProfileProblem[] = [];
  const name = normalizeName(p.name);
  const length = [...name].length;
  if (length < PROFILE_LIMITS.nameMin) problems.push("nome-curto");
  else if (length > PROFILE_LIMITS.nameMax) problems.push("nome-longo");
  else if (!NAME_PATTERN.test(name)) problems.push("nome-caracteres");
  if (
    !Number.isInteger(p.number) ||
    p.number < PROFILE_LIMITS.numberMin ||
    p.number > PROFILE_LIMITS.numberMax
  )
    problems.push("numero");
  if (!Object.hasOwn(POSITIONS, p.position)) problems.push("posicao");
  if (!Object.hasOwn(SEXES, p.sex) || !Object.hasOwn(HEIGHTS, p.height) || !Object.hasOwn(BUILDS, p.build))
    problems.push("corpo");
  if (!isValidAppearance(p)) problems.push("aparencia");
  return problems;
}
